import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent, IconButton,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    TextField, Typography
} from '@mui/material';
import {Close} from "@mui/icons-material";
import Strings from "../assets/strings";
import SelectEnum from "./selects/SelectEnum";
import {TextFieldPhone} from "./CustomTextField";
import TopBarDialog from "./topBar/TopBarDialog";
import Box from "@mui/material/Box";
import {MostrarError} from "./MostrarError";
import {IReferencia} from "../redux/types/ICliente";
import {translateText} from "../helpers";
import SelectUsoMultiples from "./selects/SelectUsoMultiples";



const initialState : IReferencia ={
    tipo:undefined,
    nombre:"",
    telefono:"",
    parentescoId:undefined,
    parentesco:""
};
export default  function ReferenciasCliente({referencias=[], onChange}:{referencias?:IReferencia[], onChange:(val:IReferencia[])=>void}){

    const [state, setState] = useState(initialState);
    const [error, setError] = useState();


    const [openNewRef, setOpenNewRef] = useState(false);
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setState({...state,[name]:value})
    };
    const deleteRef = (refIndex:number) =>{
        let refs = [...referencias];
        refs.splice(refIndex, 1);
        onChange(refs);
    };
    const addRef = ()=>{
        setError(undefined);
        let refs = [...referencias];

        if(state.tipo && state.nombre && state.telefono && state.parentescoId){
            refs.unshift(state);
            onChange(refs);
            setOpenNewRef(false);
            setState(initialState)
        }else {
            setError(translateText("completeCamposRequeridosMsj"))
        }
    };

    return <>
        <div className={"customCard"}>
            <div className={"title"}>
                <Box color={"primary.main"} fontSize={14}>{Strings.referencias}</Box>
                <Button size={"small"}  color="primary" onClick={()=>setOpenNewRef(!openNewRef)}>
                    {Strings.agregar}
                </Button>
            </div>
            {!referencias.length &&
                <Typography mt={"-3px"} mb={1} align={"center"} color={"gray"}>
                    Agregar contactos de referencia.
                </Typography>
            }
            {!!referencias.length &&
                <TableContainer>
                    <Table aria-label="simple table" size={"small"}>
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell>{Strings.tipo}</TableCell>
                                <TableCell>{Strings.nombreCompleto}</TableCell>
                                <TableCell>{Strings.telefono}</TableCell>
                                <TableCell>{Strings.parentesco}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {referencias.map((ref,i)=>{
                                return (
                                    <TableRow key={i}>
                                        <TableCell className="actionCell">
                                            <IconButton onClick={()=>deleteRef(i)} size="large">
                                                <Close className="text-red"/>
                                            </IconButton>
                                        </TableCell>
                                        <TableCell><SelectEnum value={ref.tipo} group={"tiposReferencia"}/></TableCell>
                                        <TableCell>{ref.nombre}</TableCell>
                                        <TableCell>{ref.telefono}</TableCell>
                                        <TableCell>
                                            <SelectUsoMultiples
                                                group="3"
                                                value={ref.parentescoId}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </div>
        <Dialog maxWidth="xs" onClose={()=>setOpenNewRef(false)} open={!!openNewRef}>
            <TopBarDialog title={Strings.agregar+" "+Strings.referencia} onClose={()=>setOpenNewRef(false)} nofullScreen/>
            <DialogContent>
                    <MostrarError errors={error} onClose={()=>setError(undefined)}/>
                    <SelectEnum value={state.tipo}
                                name={"tipo"}
                                label={Strings.tipo}
                                onChange={handleChange}
                                group={"tiposReferencia"}
                                margin="dense"
                                required
                    />
                    <TextField
                        name="nombre"
                        label={Strings.nombreCompleto}
                        value={state.nombre}
                        onChange={handleChange}
                        fullWidth
                        margin="dense"
                        required
                    />
                    <TextFieldPhone
                        name="telefono"
                        label={Strings.telefono}
                        value={state.telefono}
                        onChange={handleChange}
                        required
                        margin="dense"
                        fullWidth
                    />


                <SelectUsoMultiples
                    value={state.parentescoId}
                    name={"parentescoId"}
                    label={Strings.parentesco}
                    onChange={handleChange}
                    group={"3"}
                    required
                />

                </DialogContent>
                <DialogActions>
                    <Button type={"button"} color="warning" variant={"text"} onClick={()=>setOpenNewRef(false)} >
                        {Strings.cancelar}
                    </Button>
                    <Button onClick={addRef} color="primary" variant={"outlined"}>
                        {Strings.agregar}
                    </Button>
                </DialogActions>
        </Dialog>
    </>;
}
